<template>
  <div class="topNavigation">
    <!-- 弹窗遮罩 -->
    <div class="mask" v-if="maskType" @click="closeMa()"></div>
    <!-- 在线交流弹窗 -->
    <div class="ewmDialog" v-if="ewmShow" @click="closeMa()">
      <div class="ewmFont">请用微信扫码，进行在线交流</div>
      <img src="../../assets/image/query/qrcode.png" alt="" />
    </div>
    <!-- 导航部分 -->
    <div class="query_nav" ref="container">
      <div class="_navBox mt">
        <div class="_navleft">
          <img src="../../assets/image/query/logo_top.png" alt="" />
        </div>
        <div class="_navRight">
          <!-- 登录前 -->
          <div
            v-if="userLoginData.token == '' || userLoginData.token == undefined"
          >
            <div class="right_btn" @click="registerVis">注 册</div>
            <div class="right_btn" @click="loginVis">登 录</div>
          </div>
          <!-- 登录后 -->
          <div class="right_login" v-else>
            <div style="float: left">
              <el-dropdown
                trigger="click"
                size="medium"
                @command="handleCompanyChange"
              >
                <span
                  v-if="userLoginData.userName != null"
                  class="el-dropdown-link"
                  style="font-size: 18px"
                >
                  {{ userLoginData.userName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <span v-else class="el-dropdown-link" style="font-size: 18px">
                  {{ getPhone
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="1">个人中心</el-dropdown-item>
                  <el-dropdown-item :command="2">修改密码</el-dropdown-item>
                  <el-dropdown-item :command="3">退出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <!-- <div class="_login_phone">{{ userLoginData.cellPhone }}</div> -->
          </div>
          <div class="right_tabs">
            <ul>
              <li>
                <router-link :to="{ path: '/index' }">首页</router-link>
              </li>
              <li>
                <router-link :to="{ path: '/query' }">品牌查询</router-link>
              </li>
              <li @click="goAbout">
                <router-link :to="{ path: '/about' }">关于我们</router-link>
              </li>
              <li @click.stop="(ewmShow = true), (maskType = true)">
                <a>在线交流</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 登录弹窗 —— 密码登录/短信验证码登录 -->
    <el-dialog
      title=""
      :visible.sync="loginDialogVisible"
      :before-close="loginClose"
      width="480px"
    >
      <div class="login">
        <div class="login_top">
          <span :class="loginType == 0 ? 'active' : ''" @click="clickType(0)"
            >密码登录
          </span>
          <span style="margin: 0 10px">|</span>
          <span :class="loginType == 1 ? 'active' : ''" @click="clickType(1)">
            短信验证码登录</span
          >
        </div>
        <!-- 密码登录 -->
        <div class="mimaLogin" v-if="loginType == 0">
          <el-input
            style="margin-top: 20px"
            size="medium"
            v-model="accountLogin.userLoginStr"
            placeholder="请输入用户名/手机号"
          ></el-input>
          <el-input
            style="margin-top: 20px"
            size="medium"
            v-model="accountLogin.password"
            placeholder="请输入密码"
            show-password
          ></el-input>
          <div class="login_text" v-if="accountLoginTips != ''">
            {{ accountLoginTips }}
          </div>
          <div class="login_tips">
            <div class="forget" @click="forgetPassword">忘记密码？</div>
            <div class="register">
              还没有卓闻账号？
              <span
                @click="
                  (registerDialogVisible = true), (loginDialogVisible = false)
                "
                >快捷注册</span
              >
            </div>
          </div>
          <el-button
            style="width: 100%; margin-top: 20px"
            type="primary"
            size="medium"
            @click="passwordLogin"
            >登录</el-button
          >
        </div>
        <!-- 短信登录 -->
        <div class="duanxinLogin" v-else>
          <div class="login_tips">填呗用户可通过手机号直接登录</div>
          <el-input
            size="medium"
            v-model="SMSLogin.cellPhone"
            placeholder="请输入手机号"
            maxlength="11"
          ></el-input>
          <!-- 滑块 -->
          <div class="sendMessage">
            <el-input
              style="float: left; width: 50%"
              size="medium"
              v-model="SMSLogin.identityCode"
              placeholder="请输入手机验证码"
            ></el-input>
            <el-button
              style="float: right; width: 40%"
              type="primary"
              size="medium"
              :disabled="sendDisabled"
              @click="submitFormWithCaptcha(SMSLogin.cellPhone)"
              >{{ message }}</el-button
            >
          </div>
          <div class="login_text" v-if="SMSTips != ''">{{ SMSTips }}</div>
          <div class="login_tips">
            <el-checkbox v-model="SMSChecked">
              未注册手机验证后自动登录,阅读并同意
            </el-checkbox>
            <span @click="goAgreement">《卓闻品牌资源库用户服务协议》</span>
          </div>
          <el-button
            style="width: 100%; margin-top: 20px"
            type="primary"
            size="medium"
            @click="messageLogin"
            >登录</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 注册弹窗 -->
    <el-dialog
      title="欢迎注册"
      :visible.sync="registerDialogVisible"
      width="600px"
      center
    >
      <div class="register" v-if="!registerSuccess">
        <el-form ref="form" :model="registerForm" label-width="110px">
          <el-form-item label="用户名：">
            <el-input
              size="medium"
              placeholder="请输入用户名（可用于登录）"
              v-model="registerForm.userName"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码：" required>
            <el-input
              size="medium"
              placeholder="请输入密码"
              v-model="registerForm.password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号：" required>
            <el-input
              size="medium"
              placeholder="请输入手机号"
              maxlength="11"
              v-model="registerForm.cellPhone"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机验证：" required>
            <div class="sendMessage">
              <el-input
                style="float: left; width: 50%"
                size="medium"
                v-model="registerForm.identityCode"
                placeholder="请输入手机验证码"
              ></el-input>
              <el-button
                style="float: right; width: 40%"
                type="primary"
                size="medium"
                :disabled="sendDisabled"
                @click="submitFormWithCaptcha(registerForm.cellPhone)"
                >{{ message }}</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="性别：">
            <el-radio-group v-model="registerForm.sex">
              <el-radio :label="0">男</el-radio>
              <el-radio :label="1">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="出生日期：">
            <el-date-picker
              style="width: 100%"
              size="medium"
              v-model="registerForm.birthday"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择出生日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="学历：">
            <el-select
              style="width: 100%"
              size="medium"
              v-model="registerForm.education"
              placeholder="请选择学历"
            >
              <el-option
                v-for="item in educationData"
                :key="item.dictdataValue"
                :label="item.dictdataName"
                :value="item.dictdataValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="居住城市：">
            <el-select
              style="width: 49%"
              size="medium"
              v-model="registerForm.provinceCode"
              placeholder="请选择省"
              @change="getDistrictByParentCode(registerForm.provinceCode)"
            >
              <el-option
                v-for="item in provinceData"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
            <el-select
              style="width: 50%"
              size="medium"
              v-model="registerForm.cityCode"
              placeholder="请选择市"
            >
              <el-option
                v-for="item in cityData"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" v-if="registerTips != ''">
            <span style="color: red">{{ registerTips }}</span>
          </el-form-item>
          <el-form-item label="">
            <el-checkbox v-model="checked"></el-checkbox> 已阅读
            <span @click="goAgreement" style="color: #0087fa; cursor: pointer"
              >《卓闻品牌资源库用户服务协议》</span
            >
            <span
              style="color: #0087fa; float: right; cursor: pointer"
              @click="
                (registerDialogVisible = false), (loginDialogVisible = true)
              "
              >快捷登录</span
            >
          </el-form-item>

          <el-form-item>
            <el-button
              style="width: 100%"
              type="primary"
              size="medium"
              @click="register"
              >注 册</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div v-else>
        <el-result icon="success" title="注册成功">
          <template slot="extra">
            <span>{{ registerMessage }}秒后跳转登录</span>
          </template>
        </el-result>
      </div>
    </el-dialog>
    <!-- 忘记密码弹窗 -->
    <el-dialog
      title=""
      :visible.sync="changePasswordDialogVisible"
      width="550px"
      center
    >
      <div class="password">
        <el-steps direction="horizontal" :active="passwordActive" align-center>
          <el-step title="输入信息"></el-step>
          <el-step title="重置密码"></el-step>
          <el-step title="完成" description=""></el-step>
        </el-steps>
        <!-- 步骤 - 1 -->
        <div
          class="stepOne"
          style="margin-top: 50px; width: 85%"
          v-if="passwordActive == 1"
        >
          <el-form
            ref="form"
            :model="forgetPasswordOneForm"
            label-width="110px"
          >
            <el-form-item label="手机号：" required>
              <el-input
                size="medium"
                placeholder="请输入手机号"
                maxlength="11"
                v-model="forgetPasswordOneForm.cellPhone"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机验证：" required>
              <div class="sendMessage">
                <el-input
                  style="float: left; width: 50%"
                  size="medium"
                  v-model="forgetPasswordOneForm.identityCode"
                  placeholder="请输入手机验证码"
                ></el-input>
                <el-button
                  style="float: right; width: 40%"
                  type="primary"
                  size="medium"
                  :disabled="sendDisabled"
                  @click="
                    submitFormWithCaptcha(forgetPasswordOneForm.cellPhone)
                  "
                  >{{ message }}</el-button
                >
              </div>
            </el-form-item>
            <el-form-item label="">
              <span style="color: red" v-if="forgetPasswordOneTips != ''">{{
                forgetPasswordOneTips
              }}</span>
            </el-form-item>

            <el-form-item>
              <el-button
                style="width: 100%"
                type="primary"
                size="medium"
                @click="stepOne(1)"
                >下一步</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <!-- 步骤 - 2 -->
        <div
          class="stepOne"
          style="margin-top: 50px; width: 85%"
          v-if="passwordActive == 2"
        >
          <el-form
            ref="form"
            :model="forgetPasswordTweForm"
            label-width="120px"
          >
            <el-form-item label="用户名：" required>
              <span>{{ userData.userName }}</span>
            </el-form-item>
            <el-form-item label="已绑定手机号：" required>
              <span>{{ userData.cellPhone }}</span>
            </el-form-item>
            <el-form-item label="新登录密码：" required>
              <el-input
                size="medium"
                placeholder="请输入密码"
                v-model="forgetPasswordTweForm.password"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item label="确认新密码：" required>
              <el-input
                size="medium"
                placeholder="请输入密码"
                v-model="forgetPasswordTweForm.passwordAgain"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item label="">
              <span style="color: red" v-if="forgetPasswordTweTips != ''">{{
                forgetPasswordTweTips
              }}</span>
            </el-form-item>

            <el-form-item>
              <el-button
                style="width: 100%"
                type="primary"
                size="medium"
                @click="stepTwe(1)"
                >提交</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <!-- 步骤 - 3 -->
        <div
          class="stepOne"
          style="margin-top: 50px"
          v-if="passwordActive == 3"
        >
          <div class="step">
            <el-result style="width: 100px; float: left" icon="success">
            </el-result>
            <span style="font-size: 18px; float: left; line-height: 146px"
              >恭喜你，密码修改成功</span
            >
          </div>
          <div style="text-align: center">
            请牢记您新设置的密码，<span
              style="color: #0087fa; cursor: pointer"
              @click="
                (changePasswordDialogVisible = false),
                  (loginDialogVisible = true)
              "
              >快捷登录</span
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 个人中心弹窗 -->
    <el-dialog
      title="个人中心"
      :visible.sync="personalCenterDialogVisible"
      width="600px"
      center
    >
      <div class="register" v-if="!personalCenterSuccess">
        <el-form ref="form" :model="personalCenterFrom" label-width="110px">
          <el-form-item label="用户名：">
            <el-input
              size="medium"
              placeholder="请输入用户名（可用于登录）"
              v-model="personalCenterFrom.userName"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号：">
            <span>{{ getPhone }}</span>
          </el-form-item>
          <el-form-item label="性别：">
            <el-radio-group v-model="personalCenterFrom.sex">
              <el-radio :label="0">男</el-radio>
              <el-radio :label="1">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="出生日期：">
            <el-date-picker
              style="width: 100%"
              size="medium"
              v-model="personalCenterFrom.birthday"
              type="date"
              placeholder="请选择出生日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="学历：">
            <el-select
              style="width: 100%"
              size="medium"
              v-model="personalCenterFrom.education"
              placeholder="请选择学历"
            >
              <el-option
                v-for="item in educationData"
                :key="item.dictdataValue"
                :label="item.dictdataName"
                :value="item.dictdataValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="居住城市：">
            <el-select
              style="width: 49%"
              size="medium"
              v-model="personalCenterFrom.provinceCode"
              @change="getDistrictByParentCode(userLoginData.cellPhone)"
              placeholder="请选择省"
            >
              <el-option
                v-for="item in provinceData"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
            <el-select
              style="width: 50%"
              size="medium"
              v-model="personalCenterFrom.cityCode"
              placeholder="请选择市"
            >
              <el-option
                v-for="item in cityData"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <span style="color: red" v-if="personalCenterTips != ''">{{
              personalCenterTips
            }}</span>
          </el-form-item>
        </el-form>
      </div>
      <div v-else>
        <el-result icon="success" title="修改成功">
          <template slot="extra">
            <span>{{ registerMessage }}秒后自动关闭</span>
          </template>
        </el-result>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="personalCenterDialogVisible = false"
          >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="personalCenterSub"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 修改密码弹窗 -->
    <el-dialog
      title=""
      :visible.sync="resetPasswordDialogVisible"
      width="550px"
      center
    >
      <div class="password">
        <el-steps
          direction="horizontal"
          :active="changePasswordActive"
          align-center
        >
          <el-step title="输入信息"></el-step>
          <el-step title="重置密码"></el-step>
          <el-step title="完成" description=""></el-step>
        </el-steps>
        <!-- 步骤 - 1 -->
        <div
          class="stepOne"
          style="margin-top: 50px; width: 85%"
          v-if="changePasswordActive == 1"
        >
          <el-form
            ref="form"
            :model="changePasswordOneForm"
            label-width="110px"
          >
            <el-form-item label="手机号：" required>
              <span>{{ getPhone }}</span>
            </el-form-item>
            <el-form-item label="手机验证：" required>
              <div class="sendMessage">
                <el-input
                  style="float: left; width: 50%"
                  size="medium"
                  v-model="changePasswordOneForm.identityCode"
                  placeholder="请输入手机验证码"
                ></el-input>
                <el-button
                  style="float: right; width: 40%"
                  type="primary"
                  size="medium"
                  :disabled="sendDisabled"
                  @click="submitFormWithCaptcha(userLoginData.cellPhone)"
                  >{{ message }}</el-button
                >
              </div>
            </el-form-item>
            <el-form-item label="">
              <span style="color: red" v-if="forgetPasswordOneTips != ''">{{
                forgetPasswordOneTips
              }}</span>
            </el-form-item>

            <el-form-item>
              <el-button
                style="width: 100%"
                type="primary"
                size="medium"
                @click="stepOne(2)"
                >下一步</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <!-- 步骤 - 2 -->
        <div
          class="stepOne"
          style="margin-top: 50px; width: 85%"
          v-if="changePasswordActive == 2"
        >
          <el-form
            ref="form"
            :model="changePasswordTweForm"
            label-width="120px"
          >
            <el-form-item label="用户名：" required>
              <span>{{ userData.userName }}</span>
            </el-form-item>
            <el-form-item label="已绑定手机号：" required>
              <span>{{ userData.cellPhone }}</span>
            </el-form-item>
            <el-form-item label="新登录密码：" required>
              <el-input
                size="medium"
                placeholder="请输入密码"
                v-model="changePasswordTweForm.password"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item label="确认新密码：" required>
              <el-input
                size="medium"
                placeholder="请输入密码"
                v-model="changePasswordTweForm.passwordAgain"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item label="">
              <span style="color: red" v-if="forgetPasswordTweTips != ''">{{
                forgetPasswordTweTips
              }}</span>
            </el-form-item>

            <el-form-item>
              <el-button
                style="width: 100%"
                type="primary"
                size="medium"
                @click="stepTwe(2)"
                >提交</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <!-- 步骤 - 3 -->
        <div
          class="stepOne"
          style="margin-top: 50px"
          v-if="changePasswordActive == 3"
        >
          <div class="step">
            <el-result style="width: 100px; float: left" icon="success">
            </el-result>
            <span style="font-size: 18px; float: left; line-height: 146px"
              >恭喜你，密码修改成功</span
            >
          </div>
          <div style="text-align: center">
            请牢记您新设置的密码，<span style="color: #0087fa; cursor: pointer"
              >{{ changePasswordMessage }}s 后关闭</span
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDictByType, getDistrictByParentCode } from "@/api/public.js";
import {
  checkLegalAndSendMessage,
  pcHomePasswordModelRegister,
  pcHomePasswordLogin,
  pcHomeMessageRegisterOrLogin,
  pcHomeForgetPassword,
  pcHomeChangePassword,
  pcHomeShowUserInfo,
  pcHomeUpdateUserInfo,
} from "@/api/login.js";
import { setToken, getToken, removeToken } from "@/utils/auth.js";
export default {
  props: ["loginDialog", "ewmShow1", "maskType1"],
  watch: {
    loginDialog(val) {
      this.loginDialogVisible = val;
    },
    ewmShow1(val) {
      this.ewmShow = val;
    },
    maskType1(val) {
      this.maskType = val;
    },
  },
  data() {
    return {
      token: "", // 登录token
      userLoginData: "", // 用户登录数据
      maskType: false, // 遮罩背景状态
      ewmShow: false, // 在线交流弹窗状态
      loginDialogVisible: false, // 登录弹窗状态
      loginType: 0, // 登录默认选项
      accountLogin: {
        // 密码登录
        password: "", // 用户密码
        userLoginStr: "", // 用户名或者手机号
      },
      accountLoginTips: "", // 账号登录提示
      SMSLogin: {
        // 短信登录
        cellPhone: "", // 手机号
        identityCode: "", // 验证码
      },
      SMSTips: "", // 短信登录提示
      SMSChecked: false, // 短信登录阅读协议
      // namePhone: "", // 用户名/手机号——密码登录
      // password: "", // 密码——密码登录
      // phone: "", // 手机号——短信登录
      // sliderType: false, // 滑块显示状态
      // verificationCode: "", // 短信验证码
      message: "获取验证码", // 发送短信按钮文案
      timer: null, // 计时器
      sendDisabled: false, // 发送按钮禁止状态
      registerDialogVisible: false, // 注册弹窗状态
      registerForm: {
        birthday: "", // 生日 格式：1993-03-03
        cellPhone: "", // 手机号
        cityCode: "", // 城市编码
        cityName: "", // 城市名称
        education: "", // 学历
        identityCode: "", // 短信验证码
        password: "", // 用户密码
        provinceCode: "", // 省份/直辖市编码
        provinceName: "", // 省份/直辖市名称
        sex: 0, // 性别 0：男 1：女
        userName: "", // 用户名,可为空
      }, // 注册表单
      checked: false, // 注册阅读协议
      changePasswordDialogVisible: false, // 忘记密码弹窗状态
      passwordActive: 1, // 忘记密码步骤条进度
      personalCenterDialogVisible: false, // 个人中心弹窗状态
      personalCenterFrom: {}, // 个人中心表单
      personalCenterTips: "", // 个人中心提示
      personalCenterSuccess: false, // 修改个人信息成功状态
      resetPasswordDialogVisible: false, // 修改密码弹窗状态
      educationData: "", // 学历下拉
      provinceData: "", // 省
      cityData: "", // 市
      registerTips: "", // 注册提示
      registerSuccess: false, // 注册成功状态
      registerTimer: null, // 注册成功倒计时
      registerMessage: "3", // 注册成功倒计时显示
      forgetPasswordOneForm: {
        // 忘记密码步骤一表单
        cellPhone: "", // 手机号
        identityCode: "", // 验证码
      },
      forgetPasswordOneTips: "", // 忘记密码步骤一提示
      userData: "", // 忘记密码返回用户信息
      forgetPasswordTweForm: {
        // 忘记密码步骤二表单
        password: "", // 用户密码
        passwordAgain: "", // 再次确认密码
        userId: "", // 用户userId
      },
      forgetPasswordTweTips: "", // 忘记密码步骤二提示
      changePasswordOneForm: {
        // 修改密码步骤一保单
        cellPhone: "", // 手机号
        identityCode: "", // 验证码
      },
      changePasswordActive: 1, // 修改密码步骤条进度
      changePasswordTweForm: {
        // 修改密码步骤二保单
        password: "", // 用户密码
        passwordAgain: "", // 再次确认密码
        userId: "", // 用户userId
      },
      changePasswordMessage: "3", // 修改密码倒计时显示
      changePasswordTimer: null, // 修改密码倒计时
      getPhone: "", // 手机号
    };
  },

  created() {
    this.getDictByType();
    this.getDistrictByParentCode(100000);
    this.loginToken();
    // this.gerUserInfo()
  },
  mounted() {
    window.addEventListener("click", this.otherClose);
  },
  beforeDestroy() {
    /* 组件销毁的时候要移除侦听器 */
    window.removeEventListener("click", this.otherClose);
  },
  methods: {
    // 关闭扫码
    closeMa() {
      this.ewmShow = false
      this.maskType = false
      let data = {
        ewmShow: this.ewmShow,
        maskType: this.maskType,
      };
      this.$emit("close", data);
    },
    // 关闭登录弹窗
    loginClose() {
      this.loginDialogVisible = false;
      this.$emit("loginClose", this.loginDialogVisible);
    },
    // token 判断
    loginToken() {
      if (getToken() != undefined) {
        this.userLoginData = JSON.parse(localStorage.getItem("webToken"));
        this.getPhone = this.userLoginData.cellPhone.replace(
          /(\d{3})(\d{4})(\d{4})/,
          "$1****$3"
        );
      } else {
        this.userLoginData = "";
      }
    },
    //设置cookie时效
    setCookie(token, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "webToken" + "=" + token + ";path=/;expires=" + exdate.toGMTString();
    },
    // 点击打开登录弹窗
    loginVis() {
      this.loginDialogVisible = true;
      this.accountLoginTips = "";
      this.loginType = 0;
    },
    // 点击打开注册弹窗
    registerVis() {
      this.registerDialogVisible = true;
      this.registerTips = "";
    },
    // 点击打开忘记密码弹窗
    forgetPassword() {
      this.changePasswordDialogVisible = true;
      this.loginDialogVisible = false;
      this.forgetPasswordOneTips = "";
      this.forgetPasswordOneForm.cellPhone = "";
      this.forgetPasswordOneForm.identityCode = "";
      this.passwordActive = 1;
      this.$emit("loginClose", this.loginDialogVisible);
    },
    // 个人中心修改信息
    personalCenterSub() {
      pcHomeUpdateUserInfo(this.personalCenterFrom).then((res) => {
        if (res.code == 200) {
          // 注册成功跳转
          this.personalCenterSuccess = true;
          var num = 3;
          this.registerTimer = setInterval(() => {
            if (num > 0) {
              num--;
              this.registerMessage = num;
              console.log(num);
            } else {
              clearInterval(this.registerTimer);
              this.personalCenterSuccess = false;
              this.personalCenterDialogVisible = false;
              this.registerTimer = null;
              this.registerMessage = 3;
            }
          }, 1000);
          this.gerUserInfo();
        } else {
          this.personalCenterTips = res.message;
        }
      });
    },

    // 短信登录
    messageLogin() {
      // this.loginDialogVisible = false
      if (!this.SMSChecked) {
        this.SMSTips = "请阅读协议";
        return;
      }
      pcHomeMessageRegisterOrLogin(this.SMSLogin).then((res) => {
        if (res.code == 200) {
          var data = res.data;
          setToken(res.data.token);
          this.setCookie(res.data.token, 365);
          localStorage.setItem("webToken", JSON.stringify(data));
          this.loginDialogVisible = false;
          this.SMSLogin.cellPhone = "";
          this.SMSLogin.identityCode = "";
          this.SMSChecked = false;
          this.userLoginData = res.data;
          this.getPhone = this.userLoginData.cellPhone.replace(
            /(\d{3})(\d{4})(\d{4})/,
            "$1****$3"
          );
          this.$message({
            message: "登录成功",
            type: "success",
          });
          this.$emit("loginClose", this.loginDialogVisible);
          clearInterval(this.timer);
          this.message = "获取验证";
          this.sendDisabled = false;
          this.timer = null;
        } else {
          this.SMSTips = res.message;
        }
      });
    },
    // 密码登录
    passwordLogin() {
      pcHomePasswordLogin(this.accountLogin).then((res) => {
        if (res.code == 200) {
          var data = res.data;
          setToken(res.data.token);
          this.setCookie(res.data.token, 365);
          localStorage.setItem("webToken", JSON.stringify(data));
          this.loginDialogVisible = false;
          this.accountLogin.password = "";
          this.accountLogin.userLoginStr = "";
          this.userLoginData = res.data;
          this.$message({
            message: "登录成功",
            type: "success",
          });
          this.$emit("loginClose", this.loginDialogVisible);
          // location.reload()
        } else {
          this.accountLoginTips = res.message;
        }
      });
    },
    // 注册
    register() {
      console.log("注册表单", this.registerForm);
      if (this.registerForm.password == "") {
        this.registerTips = "密码不能为空";
        return;
      }
      if (this.registerForm.cellPhone == "") {
        this.registerTips = "手机号不能为空";
        return;
      }
      if (this.registerForm.identityCode == "") {
        this.registerTips = "手机验证码不能为空";
        return;
      }
      if (!this.checked) {
        this.registerTips = "请阅读协议";
        return;
      }
      pcHomePasswordModelRegister(this.registerForm).then((res) => {
        if (res.code == 200) {
          this.registerForm.birthday = "";
          this.registerForm.cellPhone = "";
          this.registerForm.cityCode = "";
          this.registerForm.cityName = "";
          this.registerForm.education = "";
          this.registerForm.identityCode = "";
          this.registerForm.password = "";
          this.registerForm.provinceCode = "";
          this.registerForm.provinceName = "";
          this.registerForm.userName = "";
          this.registerForm.sex = 0;
          // 注册成功跳转
          this.registerSuccess = true;
          var num = 3;
          this.registerTimer = setInterval(() => {
            if (num > 0) {
              num--;
              this.registerMessage = num;
              console.log(num);
            } else {
              clearInterval(this.registerTimer);
              this.registerDialogVisible = false;
              this.loginDialogVisible = true;
              this.registerSuccess = false;
              this.registerTimer = null;
            }
          }, 1000);
        } else {
          this.registerTips = res.message;
        }
      });
    },
    // 根据上级编码获取省市区列表
    getDistrictByParentCode(val) {
      this.registerForm.cityCode = "";
      this.personalCenterFrom.cityCode = "";
      getDistrictByParentCode({ parentCode: val }).then((res) => {
        if (res.code == 200) {
          if (val == "100000") {
            this.provinceData = res.data;
          } else {
            this.cityData = res.data;
          }
        }
      });
    },
    // 获取用户信息所有字典
    getDictByType() {
      getDictByType({ dictType: "education" }).then((res) => {
        if (res.code == 200) {
          this.educationData = res.data;
        }
      });
    },
    // 获取个人信息
    gerUserInfo() {
      pcHomeShowUserInfo({ userId: this.userLoginData.userId }).then((res) => {
        if (res.code == 200) {
          console.log(this.userInfo);
          // // if(res.data.education != '') {
          //   res.data.education = res.data.education;
          // // }
          this.getDistrictByParentCode(res.data.provinceCode);
          this.personalCenterFrom = res.data;
          this.userLoginData.userName = res.data.userName;
          localStorage.setItem("webToken", JSON.stringify(this.userLoginData));
        }
      });
    },
    // 登录后下拉点击事件
    handleCompanyChange(command) {
      console.log(command);
      if (command == 1) {
        this.personalCenterDialogVisible = true;
        this.personalCenterTips = "";
        this.gerUserInfo();
        return;
      }
      if (command == 2) {
        this.changePasswordActive = 1;
        this.resetPasswordDialogVisible = true;
        return;
      }
      if (command == 3) {
        removeToken();
        this.loginToken();
        return;
      }
    },
    // 忘记密码步骤/修改密码步骤
    // 步骤一
    stepOne(val) {
      if (val == 1) {
        pcHomeForgetPassword(this.forgetPasswordOneForm).then((res) => {
          if (res.code == 200) {
            this.forgetPasswordOneForm.cellPhone = "";
            this.forgetPasswordOneForm.identityCode = "";
            this.passwordActive = 2;
            this.userData = res.data;
            clearInterval(this.timer);
            this.message = "获取验证";
            this.sendDisabled = false;
            this.timer = null;
          } else {
            this.forgetPasswordOneTips = res.message;
          }
        });
      } else {
        pcHomeShowUserInfo({ userId: this.userLoginData.userId }).then(
          (res) => {
            if (res.code == 200) {
              console.log(res.data);
              this.changePasswordOneForm.cellPhone = res.data.cellPhone;
              pcHomeForgetPassword(this.changePasswordOneForm).then((res) => {
                if (res.code == 200) {
                  this.changePasswordOneForm.identityCode = "";
                  this.changePasswordActive = 2;
                  this.userData = res.data;
                  clearInterval(this.timer);
                  this.message = "获取验证";
                  this.sendDisabled = false;
                  this.timer = null;
                } else {
                  this.forgetPasswordOneTips = res.message;
                }
              });
            }
          }
        );
      }
    },
    // 步骤二
    stepTwe(val) {
      if (val == 1) {
        this.forgetPasswordTweForm.userId = this.userData.userId;
        pcHomeChangePassword(this.forgetPasswordTweForm).then((res) => {
          if (res.code == 200) {
            this.forgetPasswordTweForm.password = "";
            this.forgetPasswordTweForm.passwordAgain = "";
            this.passwordActive = 3;
            // localStorage.removeItem("token");
          } else {
            this.forgetPasswordTweTips = res.message;
          }
        });
      } else {
        this.changePasswordTweForm.userId = this.userData.userId;
        pcHomeChangePassword(this.changePasswordTweForm).then((res) => {
          if (res.code == 200) {
            this.changePasswordTweForm.password = "";
            this.changePasswordTweForm.passwordAgain = "";
            this.changePasswordActive = 3;
            // localStorage.removeItem("token");
            // 注册成功跳转
            var num = 3;
            this.changePasswordTimer = setInterval(() => {
              if (num > 0) {
                num--;
                this.changePasswordMessage = num;
                console.log(num);
              } else {
                clearInterval(this.changePasswordTimer);
                this.resetPasswordDialogVisible = false;
                this.changePasswordTimer = null;
                this.changePasswordMessage = 3;
              }
            }, 1000);
          } else {
            this.forgetPasswordTweTips = res.message;
          }
        });
      }
    },
    // 获取验证码
    submitFormWithCaptcha(phone) {
      // 直接生成一个验证码对象
      var that = this;
      var captcha = new TencentCaptcha("2065251367", function (res) {
        if (res.ret === 0) {
          let data = {
            cellPhone: phone,
            randStr: res.randstr,
            ticket: res.ticket,
          };
          checkLegalAndSendMessage(data).then((res) => {
            if (res.code == 200) {
              // 发送短信
              var num = 59;
              that.timer = setInterval(() => {
                if (num > 0) {
                  num--;
                  that.message = num + "秒后重发";
                  that.sendDisabled = true;
                  console.log(num);
                } else {
                  clearInterval(that.timer);
                  that.message = "重新获取验证";
                  that.sendDisabled = false;
                  that.timer = null;
                }
              }, 1000);
            }
          });
        } else {
          return false;
        }
      });
      // 显示验证码
      captcha.show();
    },
    // 登录弹窗切换登录方式
    clickType(item) {
      this.loginType = item;
      if (item == 0) {
        this.accountLoginTips = "";
      } else {
        this.SMSTips = "";
      }
    },
    // 点击关闭弹窗
    otherClose(e) {
      if (!this.$refs.container.contains(e.target)) this.maskType = false;
      if (!this.$refs.container.contains(e.target)) this.ewmShow = false;
    },
    // 跳转首页
    goHome() {
      this.$router.push({ path: "/index" });
    },
    // 跳转关于我们
    goAbout() {
      this.$router.push({ path: "/about" });
    },
    // 跳转用户协议
    goAgreement() {
      // 跳转新页面
      let href = this.$router.resolve({ path: "/userAgreement" });
      window.open(href.href, "_blank");
    },
  },
};
</script>

<style scoped lang='less'>
@media screen and (min-width: 0px) and (max-width: 1440px) {
  .mt {
    width: 1440px;
    margin: 0 auto;
  }
  .query {
    min-width: 1440px;
    .query_nav {
      min-width: 1440px;
      ._navBox {
        padding-left: 5px;
        padding-right: 5px;
        box-sizing: border-box;
      }
    }
  }
}
@media screen and (min-width: 1441px) and (max-width: 1920px) {
  .mt {
    width: 1680px;
    margin: 0 auto;
  }
  .query {
    min-width: 1680px;
    .query_nav {
      min-width: 1680px;
    }
  }
}
.mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}
.ewmDialog {
  padding: 20px;
  width: 500px;
  height: 410px;
  background-color: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  text-align: center;
  .ewmFont {
    font-size: 18px;
    font-weight: 400;
    text-align: center;
  }
  img {
    margin-top: 10px;
  }
}
.query_nav {
  height: 84px;
  background: #ffffff;
  box-shadow: 0px 3px 6px 0px #96a1ac;
  ._navBox {
    display: flex;
    justify-content: center;
    padding-top: 18px;
    ._navleft {
      flex: 0.5;
      .img {
        width: 146px;
        height: 47px;
        margin-top: 20px;
      }
    }
    ._navRight {
      flex: 1;
      .right_tabs {
        overflow: hidden;
        ul {
          float: right;
          overflow: hidden;
          margin-right: 34px;
          li {
            float: left;
            line-height: 51px;
            cursor: pointer;
            a {
              font-size: 24px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #000000;
              margin: 0;
              padding: 0 22px;
              height: 66px;
              display: inline-block;
            }
          }
          .router-link-active {
            border-bottom: 6px solid #0087fa;
            padding-bottom: 6px;
          }
          li:hover {
            a {
              border-bottom: 6px solid #0087fa;
              padding-bottom: 6px;
            }
          }
        }
      }
      .right_btn {
        margin-top: 7px;
        float: right;
        width: 120px;
        height: 36px;
        background: #0087fa;
        border-radius: 7px;
        font-size: 24px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #ffffff;
        line-height: 36px;
        // letter-spacing: 7px;
        text-align: center;
        cursor: pointer;
      }
      :nth-child(1) {
        margin-left: 10px;
      }
      .right_login {
        overflow: hidden;
        float: right;
        line-height: 48px;
        /deep/.header-new-drop li {
          width: 150px !important;
        }
        .el-dropdown-link {
          cursor: pointer;
        }
        ._login_phone {
          float: left;
          margin-left: 10px;
        }
      }
    }
  }
}
.login {
  padding: 10px 80px;
  box-sizing: border-box;
  .login_top {
    text-align: center;
    span {
      font-size: 18px;
      color: #333;
      cursor: pointer;
      display: inline-block;
      padding-bottom: 5px;
      font-weight: 500;
    }
    .active {
      color: #000;
      border-bottom: 1px solid #000;
      font-weight: 700;
    }
  }
  .mimaLogin {
    .login_text {
      color: red;
      font-size: 14px;
      margin-top: 25px;
      cursor: default;
    }
    .login_tips {
      overflow: hidden;
      margin-top: 20px;
      .forget {
        float: left;
        color: #999;
        cursor: pointer;
      }
      .register {
        float: right;
        span {
          color: #0087fa;
          cursor: pointer;
        }
      }
    }
  }
  .duanxinLogin {
    padding-top: 20px;
    .login_tips {
      font-size: 14px;
      color: #333;
      margin-bottom: 5px;
      span {
        color: #0087fa;
        cursor: pointer;
      }
    }
    .slider {
      margin-top: 20px;
      margin-bottom: 25px;
    }
    .sendMessage {
      margin-top: 20px;
      margin-bottom: 25px;
      overflow: hidden;
    }
    .login_text {
      color: red;
      font-size: 14px;
      cursor: default;
      margin-bottom: 5px;
    }
  }
}
.register {
  // padding: 10px 80px;
  box-sizing: border-box;
}
.step {
  text-align: center;
  overflow: hidden;
  margin: 0 auto;
  width: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/topNavigation/topNavigation.vue